module.exports = __webpack_public_path__ + "static/img/img_logo_zwds.9f99a75.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img_logo_zwds.png
// module id = wxbf
// module chunks = 1